import { defineStore } from 'pinia'

import type { DefineStoreOptions, StateTree, _GettersTree } from 'pinia'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function defineBackendStore<
  T,
  Id extends string = string,
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  S extends StateTree = {},
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  G extends _GettersTree<S> = {},
  A extends T = T,
>(
  name: Id,
  options: Omit<DefineStoreOptions<Id, S, G, A> & { actions: A }, 'id'>,
) {
  return defineStore<Id, S, G, A>(name, options)
}
